import { h, FunctionalComponent } from 'preact'

interface iProps {
  code: number
}

const Error: FunctionalComponent<iProps> = ({ code }) => {
  return (
    <div>
      Error code: {code}
    </div>
  )
}

export default Error
